<template>
  <div class="top-status">
    <div class="top-status-item">
      <div class="top-status-name">电站总数</div>
      <div class="top-status-value">
        <TransitionNumber :value="stationData.total"></TransitionNumber>
        <span class="top-status-unit">个</span></div>
    </div>
    <div class="top-status-item">
      <div class="top-status-name">总装机容量</div>
      <div class="top-status-value">
        <TransitionNumber :value="capacityValue"></TransitionNumber>
        <span class="top-status-unit">{{ capacityUnit }}</span></div>
    </div>
    <div class="top-status-item">
      <div class="top-status-name">安全运行天数</div>
      <div class="top-status-value">
        <TransitionNumber :value="stationData.days"></TransitionNumber>
        <span class="top-status-unit">天</span></div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { reactive, computed, onMounted } from 'vue'
import { getStationData } from '@/api/home'
import { formatterCapacity } from '@/utils/fortmatter'
import TransitionNumber from '@/components/TransitionNumber/index.vue'
import { getStationStatistics } from '@/api/workbench/index.js'


const stationData = reactive({
  total: 0,
  capacity: 0,
  days: 0
})

const capacityUnit = computed<string>(() => {
  if (!stationData.capacity) return 'GWh'
  return formatterCapacity(stationData.capacity).split(' ')[1]
})

const capacityValue = computed<number>(() => {
  if (!stationData.capacity) return 0
  return Number(formatterCapacity(stationData.capacity).split(' ')[0])
})

const fetchStationData = async () => {
  try {
    const res = await getStationStatistics()
    if (res.code === 200 && res.data) {
      Object.assign(stationData, res.data)
    }
  } catch (error) {
    console.error('获取电站数据失败:', error)
  }
}

onMounted(() => {
  fetchStationData()
})
</script>
<style scoped lang="scss">
.top-status {
  display: flex;
  gap: 32px;
  margin-left: 20px;
}

.top-status-name {
  color: #2E2E2E;
  font-size: 14px;
  color: #2E2E2E;
  font-weight: 300;
  text-align: left;
}

.top-status-value {
  min-width: 131px;
  height: 50px;
  font-family: "HarmonyOS Sans SC";
  font-style: normal;
  font-weight: 300;
  font-size: 40px;
  line-height: 50px;
  text-align: left;
  color: #373737;
}

.top-status-unit {
  font-size: 16px;
  line-height: 50px;
  text-align: left;
  color: #373737;
}
</style>
